'use client';

import { c as _c } from "react/compiler-runtime";
import React from 'react';
import classNames from 'classnames';
import PropTypes from 'prop-types';
const ResultsHeader = t0 => {
  const $ = _c(6);
  const {
    variant: t1,
    children
  } = t0;
  const variant = t1 === undefined ? "desktop" : t1;
  const t2 = variant !== "mobile";
  const t3 = variant === "mobile";
  let t4;
  if ($[0] !== t2 || $[1] !== t3) {
    t4 = classNames("mx-0 my-2.5 text-base font-bold", {
      "text-gray": t2,
      "text-brand block mt-[15px] mb-[7px]": t3
    });
    $[0] = t2;
    $[1] = t3;
    $[2] = t4;
  } else {
    t4 = $[2];
  }
  let t5;
  if ($[3] !== children || $[4] !== t4) {
    t5 = <div className={t4}>{children}</div>;
    $[3] = children;
    $[4] = t4;
    $[5] = t5;
  } else {
    t5 = $[5];
  }
  return t5;
};
ResultsHeader.propTypes = {
  variant: PropTypes.string,
  children: PropTypes.node
};
export default ResultsHeader;